export const SHAREHOLDERS_UPDATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Client.OfferPartnerShareholdersUpdated";
export const SHAREHOLDERS_INVALIDATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Client.OfferPartnerShareholdersInvalidated";
export const ALL_SHAREHOLDERS_INVALIDATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.OfferShareholdersInvalidated";
